// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import { FaChevronDown, FaChevronUp, FaBars} from "react-icons/fa";
// import Search from "../Search/Search";
// import Dropdown from "./DropDown";
// import { menuItems } from "../../Constants/menuItems";


// const Navbar = ({setSearchResults}) => {
//   const [openMenu, setOpenMenu] = useState(null);
//   const [showSearch, setShowSearch] = useState(true);

//   // let lastScrollY = 0;

//   // const handleScroll = () => {
//   //   if (window.scrollY > lastScrollY) {
//   //     setShowSearch(false);
//   //   } else {
//   //     setShowSearch(true);
//   //   }
//   //   lastScrollY = window.scrollY;
//   // };

//   // useEffect(() => {
//   //   window.addEventListener("scroll", handleScroll);
//   //   return () => window.removeEventListener("scroll", handleScroll);
//   // }, []);

//   const handleItemClick = (item) => {
//     if (!item.dropdown && !item.subDropdown) {
//       handleMouseLeave();

//     }
//   };


//   const handleMouseEnter = (index) => setOpenMenu(index);
//   const handleMouseLeave = () => setOpenMenu(null);

//   return (
//     <div className="fixed w-full top-0 z-10 bg-white shadow-lg">
//       {showSearch && <Search setSearchResults={setSearchResults} />}
//       <div className="flex justify-center my-3 ">
//         <ul className="flex gap-8 text-gray-700 font-medium">
//           {menuItems.map((item, index) => (
//             <li
//               key={index}
//               className="relative"
//               onMouseEnter={() => handleMouseEnter(index)}
//               onMouseLeave={handleMouseLeave}
//             >
//               <Link
//                 to={item.path}
//                 className="hover:text-purple-500 transition-colors flex items-center"
//                 onClick={() => handleItemClick(item)}
//               >
//                 {item.label}
//                 {item.dropdown && (
//                   <span className="ml-1">
//                     {openMenu === index ? <FaChevronUp /> : <FaChevronDown />}
//                   </span>
//                 )}
//               </Link>
//               {item.dropdown && openMenu === index && (
//                 <Dropdown items={item.dropdown} />
//               )}
//             </li>
//           ))}
//         </ul>
//       </div>
//     </div>
//   );
// };

// export default Navbar;


import React, { useState } from "react";
import Search from "../Search/Search";
import { menuItems } from "../../Constants/menuItems";


const Navbar = ({ setSearchResults }) => {


  return (
    <div className="navbar">
    <Search menuItems={menuItems} setSearchResults={setSearchResults} />
  </div>
  );
};

export default Navbar;
